import { DictionariesState } from './dictionaries/dictionaries.state';
import { UserState } from './user/user.store';

export const StoreList = [DictionariesState, UserState];